<nav class="navbar">
  <div class="navbar-container">
    <!-- Logo -->
    <div class="navbar-logo">
      <a routerLink="/" class="d-inline-block">
        <img src="assets/images/logo/Cyclops-logo1.png" alt="Logo" class="logo-img">
      </a>
    </div>

    <!-- Desktop Menu -->
    <ul class="navbar-menu">
      <ng-container *ngFor="let item of menuItems">
        <!-- Submenu -->
      <li class="nav-item" [class.has-children]="item.children?.length" *ngIf="item.type === 'sub'; else singleLink">
  <a [routerLink]="item.routerLink" [fragment]="item.fragment">{{ item.title }}</a>

  <ul class="dropdown">
    <ng-container *ngFor="let child of item.children">
      <li class="nav-subitem" [class.has-children]="child.children?.length">
        <a [routerLink]="child.routerLink" [fragment]="child.fragment">{{ child.title }}</a>

        <ul *ngIf="child.children" class="dropdown sub-dropdown">
          <li *ngFor="let sub of child.children">
            <a [routerLink]="sub.routerLink" [fragment]="sub.fragment">{{ sub.title }}</a>
          </li>
        </ul>
      </li>
    </ng-container>
  </ul>
</li>


        <!-- Single Link -->
        <ng-template #singleLink>
          <li class="nav-item">
            <a [routerLink]="item.routerLink" [fragment]="item.fragment">{{ item.title }}</a>
          </li>
        </ng-template>
      </ng-container>
    </ul>

    <!-- Mobile Toggle -->
    <button class="mobile-toggle" (click)="toggleMobileMenu()">
      <span *ngIf="!mobileMenuOpen">&#9776;</span>
      <span *ngIf="mobileMenuOpen">&times;</span>
    </button>
  </div>

  <!-- Mobile Menu -->
  <div class="mobile-menu" *ngIf="mobileMenuOpen">
    <ul>
      <ng-container *ngFor="let item of menuItems">
        <li>
          <button *ngIf="item.type === 'sub'; else mobileSingle"
                  (click)="toggleSubMenu(item)"
                  class="mobile-submenu-toggle">
            {{ item.title }}
            <span>{{ item.open ? '-' : '+' }}</span>
          </button>
          <ul *ngIf="item.open">
            <ng-container *ngFor="let child of item.children">
              <li>
                <a [routerLink]="child.routerLink" [fragment]="child.fragment">{{ child.title }}</a>
                <ul *ngIf="child.children">
                  <li *ngFor="let sub of child.children">
                    <a [routerLink]="sub.routerLink" [fragment]="sub.fragment">{{ sub.title }}</a>
                  </li>
                </ul>
              </li>
            </ng-container>
          </ul>
        </li>
        <ng-template #mobileSingle>
          <a [routerLink]="item.routerLink" [fragment]="item.fragment">{{ item.title }}</a>
        </ng-template>
      </ng-container>
    </ul>
  </div>
</nav>
